import { Component, Input, Output, EventEmitter, OnInit, Optional } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import Swal from 'sweetalert2';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { AuthService } from '@core/service/auth.service';
import _ from 'lodash';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-form-dialog',
  templateUrl: './form-dialog.component.html',
  styleUrls: ['./form-dialog.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    BsDatepickerModule,
  ],
})
export class FormDialogComponent implements OnInit {
  @Input() action: string = 'add';
  @Input() item: any = {};
  @Output() saved = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  itemToSave: any = {};
  isLoading: boolean = false;
  user: any;
  loading: boolean | undefined;
  imageDisplay: any;
  imageName: string | undefined;
  currentItemImage:
    | {
        fileBase64: any;
        fileName: any;
        extension: any;
        typeDocument: string;
      }
    | undefined;
  endPoint: string = 'client';
  title = 'client';
  createMessage = '';
  editMessage = '';
  deleteMessage = '';
  gender = 'M';
  itemsNaturePiece: any = [];
  itemsImage: any = [];
  itemsGenre: any = [];
  itemsCivilite: any = [];
  itemsTypeUtilisateur: any = [];
  maxBirthDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth(),
    new Date().getDate()
  );

  constructor(
    @Optional() public activeModal: NgbActiveModal,
    private restClient: RestClientService,
    private utilities: UtilitiesService,
    private authService: AuthService
  ) {
    this.user = this.authService.getCurrentUser();
  }

  dismiss() {
    this.closed.emit();
    this.activeModal?.dismiss();
  }

  ngOnInit() {
    if (this.action === 'edit') {
      this.itemToSave = { ...this.item };
      if (this.itemToSave.date_naissance)
        this.itemToSave.date_naissance = new Date(this.itemToSave.date_naissance);
      if (this.item.image_url) {
        this.imageDisplay = this.item.image_url;
      }
    } else {
      this.itemToSave = {};
    }

    let text1 = this.gender == 'M' ? 'un' : 'une';
    this.createMessage = 'Vous êtes sur le point de créer ' + text1 + ' ' + this.title;
    this.editMessage = 'Vous êtes sur le point de modifier ' + text1 + ' ' + this.title;
    this.deleteMessage = 'Vous êtes sur le point de supprimer ' + text1 + ' ' + this.title;

    this.getItemsNaturePiece();
    this.getItemsGenre();
    this.getItemsCivilite();
    this.getItemsTypeUtilisateur();
  }

  submit() {}

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];

      console.info('fileName', fileName);
      console.info('extension', extension);
      this.imageName = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        this.imageDisplay = data;
        const fileBase64 = data.split(',')[1];
        this.currentItemImage = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: 'custom type',
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }
  confirmSaveItem(item: any) {
    if (!this.isAtLeast18(item.date_naissance)) {
      this.utilities.showNotification(
        'snackbar-danger',
        'Le client doit avoir au moins 18 ans',
        'bottom',
        'center'
      );
      return;
    }

    if (!item.id) item.code = this.generateUniqueString();
    let objToSave = Object.assign({}, item);
    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id ? this.editMessage : this.createMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        // objToSave.code = objToSave.code.trim().toUpperCase();
        this.saveItem(objToSave);
      }
    });
  }

  isAtLeast18(dateNaissance: string | Date | null | undefined): boolean {
    if (!dateNaissance) return false;

    const birthDate = new Date(dateNaissance);
    if (Number.isNaN(birthDate.getTime())) return false;

    birthDate.setHours(0, 0, 0, 0);
    return birthDate <= this.maxBirthDate;
  }

  getItemsNaturePiece() {
    let request = {
      data: {},
      index: 0,
      size: 10000,
    };

    this.restClient.post('naturePiece/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsNaturePiece = res['items'];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsNaturePiece = [];
        }
      },
      (err) => {
        this.itemsNaturePiece = [];
      }
    );
  }
  getItemsGenre() {
    let request = {
      data: {},
      index: 0,
      size: 10000,
    };

    this.restClient.post('genre/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsGenre = res['items'];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsGenre = [];
        }
      },
      (err) => {
        this.itemsGenre = [];
      }
    );
  }
  getItemsCivilite() {
    let request = {
      data: {},
      index: 0,
      size: 10000,
    };

    this.restClient.post('civilite/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsCivilite = res['items'];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center'
          );
          this.itemsCivilite = [];
        }
      },
      (err) => {
        this.itemsCivilite = [];
      }
    );
  }

  saveItem(item: any) {
    console.info('item to save', item);

    this.isLoading = true;

    let itemAEnregistrer = Object.assign({}, item);

    if (this.currentItemImage && Object.keys(this.currentItemImage).length) {
      itemAEnregistrer.file_data = this.currentItemImage;
    } else {
      delete itemAEnregistrer.file_data;
    }

    if (this.itemsImage && this.itemsImage.length)
      itemAEnregistrer.itemsImage = this.itemsImage;

    itemAEnregistrer.groupe_id = this.user.groupe_id;
    itemAEnregistrer.hotel_id = this.user.hotel_id;
    let type_utilisateur_id =
      this.itemsTypeUtilisateur.find(
        (itu: any) => itu.codification === 'CLIENT'
      )?.id ?? null;
    itemAEnregistrer.type_utilisateur_id = type_utilisateur_id;
    if (!itemAEnregistrer.type_utilisateur_id) {
      this.utilities.showNotification(
        'snackbar-danger',
        'Veuillez renseigner type utilisateur',
        'bottom',
        'center'
      );
      return;
    }
    var request = {
      datas: [itemAEnregistrer],
    };

    this.restClient
      .post(
        this.endPoint + '' + (itemAEnregistrer.id ? '/update' : '/create'),
        request
      )
      .subscribe(
        (res: any) => {
          console.info('resul', res);
          this.isLoading = false;

          if (!res['hasError']) {
            this.utilities.showNotification(
              'snackbar-success',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center'
            );
            this.saved.emit();
            this.activeModal?.close(true);
          } else {
            if (res['status'] && res['status']['message']) {
              this.utilities.showNotification(
                'snackbar-danger',
                this.utilities.formatMsgServeur(res['status']['message']),
                'bottom',
                'center'
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.getMessageEndPointNotAvailble(),
            'bottom',
            'center'
          );
          this.loading = false;
        }
      );
  }

  generateUniqueString() {
    var timestamp = new Date().getTime();
    var randomNumber = Math.floor(Math.random() * 1000000);

    var uniqueString = timestamp.toString() + randomNumber.toString();
    return uniqueString;
  }
  capitalize(str: any) {
    return str.replace(/^\w/, (c: string) => c.toUpperCase());
  }

  getItemsTypeUtilisateur() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient.post('typeUtilisateur/getByCriteria', request).subscribe(
      (res: any) => {
        console.info('itemsTypeUtilisateur', res);

        if (res && res['items']) {
          this.itemsTypeUtilisateur = _.orderBy(
            res['items'],
            ['libelle'],
            ['asc']
          );
        } else {
          this.itemsTypeUtilisateur = [];
        }
      },
      (err) => {}
    );
  }
}
